export enum QuestionOptionTypeEnum {
  states = "states",
}
